/**
 * Форматирование дат в московском времени для админки.
 * Даты из API без таймзоны считаются московским временем (так хранится в БД).
 */
const MOSCOW_TZ = 'Europe/Moscow';

/**
 * Если строка даты без таймзоны (нет Z или +03:00 и т.д.) — считаем московским временем.
 */
function parseAsMoscowIfNeeded(dateValue) {
    if (dateValue == null || dateValue === '') return null;
    if (typeof dateValue === 'number') return new Date(dateValue);
    if (typeof dateValue !== 'string') return dateValue;
    const s = dateValue.trim();
    // ISO без суффикса таймзоны (Z или +HH:MM / -HH:MM) — в БД хранится Москва
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/[Z+-]\d{2}:?\d{2}$/.test(s) && !s.endsWith('Z')) {
        return new Date(s + '+03:00');
    }
    return new Date(s);
}

export function formatDateMoscow(dateValue) {
    const d = parseAsMoscowIfNeeded(dateValue);
    if (!d || Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('ru-RU', {
        timeZone: MOSCOW_TZ,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

/** То же, но с секундами (для логов). */
export function formatDateMoscowWithSeconds(dateValue) {
    const d = parseAsMoscowIfNeeded(dateValue);
    if (!d || Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString('ru-RU', {
        timeZone: MOSCOW_TZ,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}

export function formatDateMoscowDateOnly(dateValue) {
    const d = parseAsMoscowIfNeeded(dateValue);
    if (!d || Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('ru-RU', {
        timeZone: MOSCOW_TZ,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}
